/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .fill {
    fill: ${theme.color.themeTxt};
  }
`

export default function LogoutIco() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" css={Color}>
      <g id="그룹_6969" data-name="그룹 6969" transform="translate(-245 -208)">
        <rect id="사각형_6695" data-name="사각형 6695" width="18" height="18" transform="translate(245 208)" fill="#eee" opacity="0"/>
        <g id="그룹_7159" data-name="그룹 7159" transform="translate(247.928 210.475)">
          <path id="패스_6709" className="fill" data-name="패스 6709" d="M-151.311,173.6a.839.839,0,0,1-.838-.838v-4.639a.839.839,0,0,1,.838-.838.839.839,0,0,1,.838.838v4.639A.839.839,0,0,1-151.311,173.6Z" transform="translate(157.383 -167.286)" fill="#eee"/>
          <path id="패스_6710" className="fill" data-name="패스 6710" d="M-150.76,180.07A6.08,6.08,0,0,1-156.832,174a6.049,6.049,0,0,1,2-4.476.836.836,0,0,1,1.184.061.837.837,0,0,1-.061,1.184A4.37,4.37,0,0,0-155.156,174a4.4,4.4,0,0,0,4.4,4.395,4.4,4.4,0,0,0,4.4-4.4,4.37,4.37,0,0,0-1.442-3.231.839.839,0,0,1-.061-1.185.838.838,0,0,1,1.185-.06,6.056,6.056,0,0,1,2,4.475A6.08,6.08,0,0,1-150.76,180.07Z" transform="translate(156.832 -167.049)" fill="#eee"/>
        </g>
      </g>
    </svg>
  )
}
